import BaseService from '_services/rest/base';

class ImageService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}`;
  }

  convertMultipleSVGsToEPS(svgList) {
    return this.request(`${this.getUrl()}convert-multiple-svg-to-eps`, { files: svgList }, 'post', 'json', {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }).then(response =>
      response,
    ).catch(error => {
      console.error('Erro ao converter múltiplos SVGs:', error);
      throw error;
    });
  }
}

export default new ImageService();
